import styled from '@emotion/styled';
import React from 'react';
import { useI18n } from '~Hooks';
import { Box } from '~Styles';

const BlobBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Cpath fill='%23f8f8f8' d='M139.4 51.3c14.8 5.2 32 12.6 39.7 25.5 7.6 13 5.6 31.5.5 49.6-5.2 18-13.6 35.4-27.4 45.7-13.8 10.2-33 13.1-48.1 7.5C88.9 174 77.9 159.8 66 149c-11.8-10.8-24.5-18.4-33-30.5-8.5-12.2-12.7-29-9.1-44.2 3.6-15.2 15.2-28.7 29.2-34.2 14-5.4 30.4-2.7 44.8.2 14.4 2.8 26.7 5.9 41.5 11Z'/%3E%3C/svg%3E");
  min-height: 400px;
  background-repeat: no-repeat;
  background-size: cover;
  color: var(--colorBlueGray1200);
  & > p,
  h2 {
    margin: 8px 0;
  }
`;

interface NoContentProps {
  refetch: () => void;
}

export default function NoContent({ refetch }: NoContentProps) {
  const { i18n } = useI18n();
  return (
    <BlobBox fluid>
      <h2>{i18n('General.NoContent')}</h2>
      <p style={{ maxWidth: '200px', textAlign: 'center' }}>{i18n('GC.NoContent.Info')}</p>
      <Box as="p" color="colorUIBlue" onTouchEnd={() => refetch()}>
        {i18n('GC.OrReload')}
      </Box>
    </BlobBox>
  );
}
